import KeenSlider from "keen-slider";

/**
 * Gallery editorial slider init and event listeners
 * @param {Element} sliderWrapperEle - main slider wrapper element
 * @param {Element} popupWrapperEle - Popup slider wrapper element
 */
window.galleryEditorialInit = function galleryEditorialInit(
  sliderWrapperEle,
  popupWrapperEle
) {
  let sliderEle = sliderWrapperEle?.querySelector(".gallery-editorial-slider");
  let popupSliderEle = popupWrapperEle?.querySelector(
    ".gallery-editorial-popup-slider"
  );
  let editorialPopupTriggerEles = sliderWrapperEle?.querySelectorAll(
    ".gallery-editorial-popup-trigger"
  );
  let editorialPopupCloseEle = popupWrapperEle?.querySelector(
    ".close-editorial-popup"
  );

  // init gallery editorial slider
  var slider = new KeenSlider(
    sliderEle,
    {
      loop: true,
      slides: { perView: 1 },
      rtl: window.rtlView,
      breakpoints: {
        "(min-width: 768px)": {
          slides: { perView: "auto", spacing: 30 },
        },
      },
    },
    [galleryEditorialNavigation]
  );

  // init popup slider
  var sliderPopup = new KeenSlider(
    popupSliderEle,
    {
      loop: true,
      rtl: window.rtlView,
      slides: { perView: 1 },
    },
    [galleryEditorialNavigation]
  );

  // open popup gallery editorial
  editorialPopupTriggerEles.forEach((ele) => {
    ele.addEventListener("click", (e) => {
      let currentIndex = Number(ele.dataset.index);

      // change popup slider active slide
      changePopSliderIndex(currentIndex);

      // show popup slider
      galleryEditorialPopupVisibility(true, popupWrapperEle);
    });
  });

  // Popup Close Listener
  editorialPopupCloseEle.addEventListener("click", (e) => {
    galleryEditorialPopupVisibility(false, popupWrapperEle);
  });

  /**
   * Change popup slider current active slide
   * @param {Number} index - slide position index
   */
  function changePopSliderIndex(index) {
    sliderPopup.moveToIdx(index, false, {
      duration: 0,
    });
  }

  /**
   * Control element Visibility Show (true) or Hide (false)
   * @param {Boolean} status - Show or hide element
   * @param {Element} ele - Element for visibility control
   */
  function galleryEditorialPopupVisibility(status, ele) {
    if (status) {
      ele.classList.remove("hidden");
      document.body.classList.add("lock-scroll");
    } else {
      ele.classList.add("hidden");
      document.body.classList.remove("lock-scroll");
    }
  }

  /**
   * Slider navigation (Only dots)
   * @param {Object} slider - slider object
   */
  function galleryEditorialNavigation(slider) {
    let wrapper, dots;

    let mainSlider = slider.container.classList.contains(
      "gallery-editorial-slider"
    );

    const observer = new ResizeObserver(function () {
      slider.update();
    });

    function markup(remove) {
      wrapperMarkup(remove);
      dotMarkup(remove);
    }

    function removeElement(elment) {
      elment.parentNode.removeChild(elment);
    }
    function createDiv(className) {
      var div = document.createElement("div");
      var classNames = className.split(" ");
      classNames.forEach((name) => div.classList.add(name));
      return div;
    }

    function wrapperMarkup(remove) {
      if (remove) {
        var parent = wrapper.parentNode;
        while (wrapper.firstChild)
          parent.insertBefore(wrapper.firstChild, wrapper);
        removeElement(wrapper);
        return;
      }
      wrapper = createDiv("navigation-wrapper");
      slider.container.parentNode.appendChild(wrapper);
      wrapper.appendChild(slider.container);
    }

    function dotMarkup(remove) {
      if (remove) {
        removeElement(dots);
        return;
      }
      dots = createDiv("dots");
      slider.track.details.slides.forEach((_e, idx) => {
        var dot = createDiv("dot");
        dot.addEventListener("click", () => slider.moveToIdx(idx));
        dots.appendChild(dot);
      });
      wrapper.appendChild(dots);
    }

    function updateClasses() {
      var slide = slider.track.details.rel;
      Array.from(dots.children).forEach(function (dot, idx) {
        idx === slide
          ? dot.classList.add("dot--active")
          : dot.classList.remove("dot--active");
      });
    }

    function updateHeight() {
      slider.container.style.height = `${
        slider.slides[slider.track.details.rel].querySelector(
          ".slide-img-wrapper"
        ).offsetHeight
      }px`;
    }

    slider.on("created", () => {
      markup();
      updateClasses();
      observer.observe(slider.container);
      if (mainSlider) updateHeight();
    });
    slider.on("optionsChanged", () => {
      markup(true);
      markup();
      updateClasses();
    });
    slider.on("slideChanged", () => {
      updateClasses();
      if (mainSlider) updateHeight();
    });
    slider.on("destroyed", () => {
      markup(true);
    });
  }
};
